import { useAppDispatch, useAppSelector } from 'store/storeHooks';
import { useEffect, useState } from 'react';
import { fetchUserProfileThunk, resetUserState, setProfile } from 'store/user/userSlice';
import { STATUS } from 'store/statuses';
import { useAuth } from '@resmed/identity-spa-auth-react';
export function useUserData() {
    const dispatch = useAppDispatch();
    const { profile, status, error } = useAppSelector((state) => state.user);
    useEffect(() => {
        if (status === STATUS.IDLE) {
            dispatch(fetchUserProfileThunk());
        }
    }, [dispatch, status]);
    return { profile, status, error };
}
export function useMapClaimsToProfile() {
    const dispatch = useAppDispatch();
    const { claims } = useAuth();
    const profile = useAppSelector((state) => state.user.profile);
    const firstName = claims === null || claims === void 0 ? void 0 : claims.firstName;
    const lastName = claims === null || claims === void 0 ? void 0 : claims.lastName;
    const subject = claims === null || claims === void 0 ? void 0 : claims.subject;
    useEffect(() => {
        if (!firstName && !lastName && !subject) {
            return;
        }
        if (subject && profile.subject && profile.subject !== subject) {
            dispatch(resetUserState());
            dispatch(setProfile(Object.assign(Object.assign(Object.assign({}, (firstName && { firstName })), (lastName && { lastName })), { subject })));
            return;
        }
        const updates = {};
        if (subject && !profile.subject) {
            updates.subject = subject;
        }
        // Keep names already supplied by the profile page or edited by the user.
        if (firstName && !profile.firstName) {
            updates.firstName = firstName;
        }
        if (lastName && !profile.lastName) {
            updates.lastName = lastName;
        }
        if (Object.keys(updates).length > 0) {
            dispatch(setProfile(updates));
        }
    }, [firstName, lastName, subject, profile.firstName, profile.lastName, profile.subject, dispatch]);
}
export const useForm = (values = {}) => {
    const [formValues, setFormValues] = useState(values);
    const handleChange = (key, value) => {
        setFormValues((prevValues) => (Object.assign(Object.assign({}, prevValues), { [key]: Object.assign(Object.assign({}, prevValues[key]), { value: value }) })));
    };
    return { formValues, setFormValues, handleChange };
};
